 <template>
  <div @click="$sidebar.displaySidebar(false)">
		<div class="row">
      <div class="col-xl-8 mb-0 mb-xl-0">
          <div class="card shadow">
              <div class="card-body">
                <h4 class="mb-3">カテゴリー一覧
                  <base-button  v-show= "permission['category-create']"
                    type="primary"
                    class="mb-3 float-right"
                    @click="modal = true"
                  >新規登録</base-button>
                </h4>
     
                <div class="el-table__body-wrapper">
							<table class='table table-striped el-table__body'>
								<thead>
									<tr class="el-table__row">
										<th scope="col">カテゴリーID</th>
										<th scope="col" class=" cat-col">カテゴリー名</th>
                    <th scope="col">&nbsp;</th>
									</tr>
								</thead>
								<tbody>
                  <tr v-for="(category, key) in categories" :key="key" class="el-table__row">
                    <td class="el-table_1_column_1"> {{ category.id }} </td>
                    <td  class="el-table_1_column_3 cat-col"> {{ category.category_label }} </td>
                     <td>
                      <button v-show= "permission['category-delete']" class="delete-btn btn" @click="doDelete(category.id, category.category_label)">削除</button>
                     </td>
                  </tr>
				
        
								</tbody>
							</table>
              <confirm-dialogue ref="confirmDialogue"></confirm-dialogue> 
                    </div>
           

	</div>
                </div>
            </div>
            
        </div>


    <!--Form modal-->

            <modal :show.sync="modal">
              <h4 slot="header" class="modal-title">カテゴリーの新規登録</h4>
              <form role="form" @submit.prevent="save">
              <div class="form-group"  v-bind:class="{  'text-danger has-error': errors.category }">
                  <label for="message">カテゴリー名<span class="badge badge-required">必須</span></label>
                   <!--<small class="form-text text-muted">カテゴリーの値と名異なる場合「カテゴリー名:カテゴリー値」よに登録してください<br></small>-->
                  <input type="text" v-model="category" class="form-control" name="category" id="category" />
                  <p v-for="(error,key) in errors.category" :key="key" class="error-text" >{{error}}</p>
              </div>

              <div class="form-group text-center"><base-button native-type="submit" type="primary">新規登録する</base-button></div>
              </form>
            </modal>
  
    
  </div>
</template>
<script>

import ConfirmDialogue from './ConfirmDialogue.vue'
export default {
  components: {
    ConfirmDialogue
  },
  name: "category",
  props: ['categoryData'],
  data() {
    return {
      id: null,
      permission:[],
      categories: {},
      selectedDefaultSelection: '',
      isChecked: true,
      errors: {},
      error : false,
      loading: false,
      info:null,
      modalForm:false,
      category: "",
      modal:false,
      siteId: null,
    }
  },
  computed: {
  		 
    },
    mounted() {
        this.categories= JSON.parse(this.categoryData);
        console.log(this.categories);
        this.siteId = window.PushL.site_id;
        console.log(this.siteId );
        this.permission = window.PushL.permission_list;
    },
  methods: {
            
     save() {
      this.loading = true;
      this.errors = {};
      this.error = false;
      console.log('saving category');
      axios.post('/category/' + this.siteId + '/store', {
      		category:this.category
      	}).then(response => {
        this.loading = false;
        //this.info = response.data.info;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
        //this.id = response.data.result.id;
        this.categories = response.data.result;
        this.category = "";
        this.modal = false;
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
          //this.info = error.response.data.info;
          this.$toast(error.response.data.info, {
            toastClassName: "toaster"
          })
          this.error = true;
           this.loading = false;
        }
      });
    },
    async doDelete(id, label) {
            var confirmDialog = this.$refs.confirmDialogue;
            console.log(confirmDialog)
            const ok = await confirmDialog.show({
                title: 'カテゴリーを削除',
                message: '「'+label+'」を削除しますか？',
                okButton: 'はい',
                cancelButton: 'いいえ',
            })
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            try {
              if (ok) {
                  this.deleteCategory(id);
              } 
            }
            catch(error){

            }
        },
        deleteCategory(id) {
          this.loading = true;
      this.errors = {};
      this.error = false;
      axios.post('/category/' + this.siteId + '/delete', {
      		id:id
        }).then(response => {
        this.loading = false;
        //this.info = response.data.info;
        this.$toast(response.data.info, {
          toastClassName: "toaster"
        })
        if(response.data.result) {
          this.categories = response.data.result;
        }
         
        //this.id = response.data.result.id;
      }).catch(error => {
        console.log(error)
        if (error.response.status === 422) {
          this.$toast(error.response.data.info, {
            toastClassName: "invalid-feedback"
          })
          this.error = true;
           this.loading = false;
        } else if (error.response.status === 419) {
          alert("ページセッション切りましたので、削除できませんでした。ページをリロードしてください")
        }
      });
        }
  }
}
</script>
<style scoped>
.delete-btn{
  padding:0;
  color:#5e72e4;
  font-weight:700;
}
.delete-btn:focus,
.delete-btn:hover {
  box-shadow:none;
  text-decoration:underline;
 
}

.el-table__body-wrapper {
    overflow: auto;
    width: 100%;
    max-height: 600px;

}
.cat-col {
  width: 70%;
}
   
</style>
